import { getRequest } from '../../utils'
import { realtyServiceUrl } from '../../urls'

export const startOlxImportReq = () => {
  return getRequest(`${realtyServiceUrl}/jobs/importFromOlx`)
}

export const startDomRiaImportReq = () => {
  return getRequest(`${realtyServiceUrl}/jobs/importFromDomRia`)
}
